import { Link } from "react-router";
import { formatDateLabel, formatLongDate } from "@shared/time.ts";

export function DateStrip({
  dates,
  selected,
  hrefFor,
}: {
  dates: string[];
  selected?: string;
  hrefFor: (date: string) => string;
}) {
  return (
    <div className="date-strip" role="list">
      {dates.map((date) => {
        const selectedChip = selected === date;
        return (
          <Link
            key={date}
            role="listitem"
            className={`date-chip ${selectedChip ? "selected" : ""}`}
            to={hrefFor(date)}
            aria-current={selectedChip ? "date" : undefined}
            aria-label={formatLongDate(date)}
          >
            <span className="dow">{formatDateLabel(date).slice(0, 3)}</span>
            <span className="num">{date.slice(8)}</span>
          </Link>
        );
      })}
    </div>
  );
}
